<ng-container>
  <aodocs-google-sign-in *ngIf="displayGoogle" class="sign-in-buttons" (clickEvent)="startGoogleLogin()"></aodocs-google-sign-in>

  <aodocs-microsoft-sign-in
    *ngIf="displayMicrosoft"
    class="sign-in-buttons"
    (clickEvent)="startMicrosoftLogin()"
  ></aodocs-microsoft-sign-in>

  <aodocs-password-sign-in *ngIf="displayPassword" class="sign-in-buttons" (clickEvent)="startPasswordLogin()"></aodocs-password-sign-in>
</ng-container>
